module.exports = __webpack_public_path__ + "static/img/m-H1A.7121bfce.png";